import apiClient from '../api/apiClient.js';
import { createAdminService } from './adminService';
import { createAuthService } from './authService';
import { createTransactionService } from './transactionService';
import { createWalletService } from './walletService';
import { createAdminAirdropService } from './adminAirdropService';
import { createRussianBankService } from './russianBankService';

// Creation des instances de service avec injection de dependance
const adminService = createAdminService(apiClient);
const authService = createAuthService(apiClient);
const transactionService = createTransactionService(apiClient);
const walletService = createWalletService(apiClient);
const adminAirdropService = createAdminAirdropService(apiClient);
const russianBankService = createRussianBankService(apiClient);

// Export de tous les services
export {
  apiClient,
  adminService,
  authService,
  transactionService,
  walletService,
  adminAirdropService,
  russianBankService
};

// Export de compatibilité pour AuthContext
export const api = apiClient; 